enum WorkOrderStatus {
  CANCELLED = 'CANCELLED',
  CREATED = 'CREATED',
  STARTED = 'STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  TO_BE_SCHEDULED = 'TO_BE_SCHEDULED',
  TO_BE_CONSIDERED = 'TO_BE_CONSIDERED',
  COMPLETED = 'COMPLETED',
  SUSPENDED = 'SUSPENDED',
  SCHEDULED = 'SCHEDULED',
  FINISHED = 'FINISHED',
  VALIDATED = 'VALIDATED',
  NO_STATUS = 'NO_STATUS'
}

export default WorkOrderStatus;
